import { TitleBroadcastService } from '../../../services/title-broadcast.service';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {User} from '../../../dto/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {TrackingLocation} from '../../../dto/tracking-location';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {UserRole} from '../../../dto/user-role';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {takeUntil} from 'rxjs/internal/operators';
import {MatSelectChange} from '@angular/material';
import {ChemistLocation} from '../../../dto/chemist-location';
import {DoctorLocation} from '../../../dto/doctor-location';

@Component({
  selector: 'app-doctor-chemist-location',
  templateUrl: './doctor-chemist-location.component.html',
  styleUrls: ['./doctor-chemist-location.component.scss']
})
export class DoctorChemistLocationComponent implements OnInit, AfterViewInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>( 1 );
    userFilter: FormControl = new FormControl();
    chemistLocationList: ChemistLocation[] = [];
    doctorLocationList: DoctorLocation[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    userRoles: UserRole[];

    showDoctors = new FormControl(false);
    showChemists = new FormControl(false);
    filters = {
        'MarketIdList': null,
        'ShowChemist': true,
        'ShowDoctor': true
    };

    userType = 'ORGANIZATION_USER';

    private _unsubscribeAll: Subject<any>;

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService ,private titleBroadcastService: TitleBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Doctor/Chemist Location')
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    ngOnInit(): void {
        this.service.getUserRoleList( { } ).subscribe( pUserRoles => this.userRoles = pUserRoles );


        this.userFilter.valueChanges.pipe( takeUntil( this._unsubscribeAll ) ).subscribe( () => {
            if ( !this.userList ) {
                return;
            }

            const search = this.userFilter.value;
            if ( !search ) {
                this.filteredUserList.next( this.userList.slice() );
                return;
            }

            this.filteredUserList.next( this.userList.filter( user => user.Name.toLowerCase().indexOf( search.toLowerCase() ) > -1 || user.Code.toLowerCase().indexOf( search.toLowerCase() ) > -1 ) );
        } );
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }

    getUserList(): void {
        let marketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                marketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.service.getUserList( { ResponseFields: 'Id,Code,Name,Active', UserType: this.userType, MarketIdList: marketIdList } ).subscribe( userList => {
            this.userList = userList;
            this.filteredUserList.next( this.userList.slice() );
        } );
    }

    _resetChildDropdowns( pParentRank: number ): void {
        this.marketLevels.forEach( marketLevel => {
            if ( marketLevel.Rank > pParentRank ) {
                this.selectedMarket[ marketLevel.Rank ] = null;
                this.markets[ marketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildDropdowns( market.MarketLevel.Rank );
            if ( this.marketLevels[ market.MarketLevel.Rank ] ) {
                this.service.getMarketList( {
                    MarketLevelId : this.marketLevels[ market.MarketLevel.Rank ].Id,
                    ParentMarketId: market.Id,
                    Active        : true
                } ).subscribe( marketListResponse => {
                    this.markets[ market.MarketLevel.Rank + 1 ] = marketListResponse;
                } );
            }
        }
        else {
            this._resetChildDropdowns( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
    }

    getLocationList(): void {
        this.filters.MarketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                this.filters.MarketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.loadingData = true;
        this.service.getChemistAndDoctorLocationList( this.filters ).subscribe( locationList => {
            this.loadingData = false;
            // if ( locationList.length > 0 ) {
            //     this.lat = locationList[ 0 ].Latitude;
            //     this.lng = locationList[ 0 ].Longitude;
            // }

            this.chemistLocationList = locationList['ChemistList'];
            this.doctorLocationList = locationList['DoctorList'];
        }, error => {
            this.loadingData = false;
        } );
    }

}
